module.exports = "/build/web/svg/social/small/email.044d4187a434f1a093e6dea10d372aed.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/small/email.svg
// module id = 192
// module chunks = 24